import { Storm } from '@mui/icons-material';
import { Grid, Paper, Typography, Chip, Divider } from '@mui/material';
import { useAnalyzers } from 'features/analyzers/api/getAnalyzers';
import { useDishes } from 'features/dishes/api/getDishes';
import { useLocations } from 'features/locations/api/getLocations';
import { Fragment } from 'react';
import { useAppSelector } from '../../app/hooks';
import { useGetAnalyzerIdsForDish } from './hooks/useGetAnalyzerIdsForDish';
import { getWeatherAlertMap } from './utils/dataBuilders';
import WeatherAlertIcon from './WeatherAlertIcon';

const WeatherAlertWidget = () => {
  const { data: analyzers } = useAnalyzers({});
  const { data: dishes } = useDishes({});
  const { data: locations } = useLocations({});
  const getAnalyzerIdsForDish = useGetAnalyzerIdsForDish();
  const useImperial = useAppSelector(
    (state) => state.auth.user?.us_customary_units
  );
  const weatherAlertMap = getWeatherAlertMap(
    dishes,
    locations,
    useImperial,
    getAnalyzerIdsForDish
  );

  return (
    <Grid item xs={12} container component={Paper} justifyContent={'center'}>
      <Grid item container xs={12} alignItems='center' justifyContent='center'>
        <Storm />
        <Grid item style={{ marginLeft: '.3rem' }}>
          <Typography
            component='h4'
            variant='h6'
            style={{ textAlign: 'center' }}
          >
            Weather Alerts
          </Typography>
        </Grid>
      </Grid>
      <Grid
        style={{
          paddingLeft: '1rem',
          paddingRight: '1rem',
          overflow: 'auto',
          maxHeight: '15rem',
        }}
        container
        item
        xs={12}
        direction='column'
        wrap='nowrap'
      >
        {Object.keys(weatherAlertMap).length === 0 && (
          <Typography sx={{ pb: '1rem', pt: '1rem' }} variant='body2'>
            No active alerts.
          </Typography>
        )}
        {Object.keys(weatherAlertMap).map((dishName, idx) => (
          <Fragment key={idx}>
            <Divider />
            <Grid
              item
              container
              direction='column'
              style={{ paddingTop: '1rem' }}
            >
              <Typography sx={{ pr: '1rem' }}>{dishName}</Typography>
              {weatherAlertMap[dishName].rows.map((row, idx) => (
                <Grid
                  container
                  alignItems='center'
                  style={{ paddingLeft: '2rem' }}
                  item
                  key={idx}
                >
                  <WeatherAlertIcon
                    condition={row.condition}
                    warning={row.warning}
                  />
                  <Typography variant='body2' sx={{ pl: '.2rem' }}>
                    {row.alertText}
                  </Typography>
                </Grid>
              ))}
            </Grid>
            <Grid
              item
              container
              style={{ paddingBottom: '1rem', paddingLeft: '2rem' }}
              alignItems='center'
            >
              {weatherAlertMap[dishName].analyzerIds.length > 0 && (
                <Grid item>
                  <Typography variant='body2'>Analyzers: </Typography>
                </Grid>
              )}
              {weatherAlertMap[dishName].analyzerIds.map((id, idx) => (
                <Chip
                  sx={{ ml: '.2rem' }}
                  label={
                    analyzers?.find((analyzer) => analyzer.id === id)?.name
                  }
                  variant='outlined'
                  key={idx}
                />
              ))}
            </Grid>
          </Fragment>
        ))}
      </Grid>
    </Grid>
  );
};

export default WeatherAlertWidget;
